import React from "react";

import Select from "react-select";

import Form from 'react-bootstrap/Form';

import styles from "./DropdownFacet.module.css";

const DropdownFacet = (props) => {
	const options = {
		'placeholder': props.placeholder,
		'onChange': props.onChange,
		'isClearable': true,
		'options': props.options
	};

	if(props.isMulti) {
		options['isMulti'] = 'isMulti';
	}

	return (
		<Form.Group className="mb-3">
			<div className={styles.facet}>
				<div className={styles.facetLabel}>
					{props.label}
				</div>
				<div className="facet__control">
					<Select {...options} />
				</div>
			</div>
		</Form.Group>
	);
}
export default DropdownFacet;